import { Button } from '@library/components/buttons';
import { Modal } from '@library/components/modals/Modal';
import type { PaymentsCard } from '@library/types/payments';
import { useNormalizedMethodData } from '@library/components/table/payments/methods/hooks/useNormalizeMethodData';

interface PaymentMethodDetailProps {
  card: PaymentsCard;
  onCancelModal: () => void;
}

interface FieldProps {
  classes?: string;
  icon?: JSX.Element | null;
  subTitle2?: string;
  subTitle: string;
  title: string;
}

const Field = ({
  classes = 'col-span-3',
  icon = null,
  subTitle,
  subTitle2 = '',
  title
}: FieldProps) => {
  return (
    <div className={classes}>
      <div className="text-sm">{title}</div>
      <div>
        {icon}
        <div className="inline-block text-xs">{subTitle}</div>
        {subTitle2 && <div className="text-xs">{subTitle2}</div>}
      </div>
    </div>
  );
};

export const PaymentMethodDetailModal = ({
  card,
  onCancelModal
}: PaymentMethodDetailProps) => {
  const { data: normalizedData } = useNormalizedMethodData(card);
  const defaultStr = '-';

  return (
    <Modal isOpen onCancelModal={onCancelModal} maxWidth="md">
      <div className="bg-soFresh-100 outline-hidden focus:outline-hidden relative w-full flex-col rounded-lg border border-solid border-gray-600 shadow-lg">
        <div className="border-soFresh-140 flex h-14 items-start justify-between rounded-t border-b border-solid">
          <h3 className="flex h-full items-center justify-center px-5 text-2xl">
            Payment Method
          </h3>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-6 gap-8">
            <Field
              title="STATUS"
              subTitle={normalizedData.status || defaultStr}
            />
            <Field
              title="PAYMENT METHOD"
              subTitle={normalizedData.type || defaultStr}
            />
            <Field
              title="LAST 4"
              subTitle={normalizedData.lastDigits || defaultStr}
            />
            <Field title="EXP" subTitle={normalizedData.exp || defaultStr} />
            <Field title="NAME" subTitle={normalizedData.name || defaultStr} />
            <Field title="ZIP" subTitle={normalizedData.zip || defaultStr} />
            {normalizedData.deleted && (
              <>
                <Field title="DELETED AT" subTitle={normalizedData.deletedAt} />
                <Field title="DELETED BY" subTitle={normalizedData.deletedBy} />
              </>
            )}
          </div>
        </div>
        <div className="ml-auto flex h-full items-end justify-end">
          <Button
            className="bg-stankonia-100 text-soClean-100 my-6 mr-6 flex justify-center rounded-lg p-3 text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
            title="PaymentMethodDetailCloseButton"
            onClick={onCancelModal}
            type="button"
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};
